import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastNextkeyNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M24 12.0065C24.0017 11.6972 23.8858 11.3877 23.6497 11.1516L16.8294 4.33008C16.6042 4.10488 16.2924 3.99248 15.9804 3.99268V12.0065H24Z"
        fill={color}
      />
      <path
        d="M15.9804 20.0261C16.2897 20.0278 16.5992 19.9119 16.8353 19.6758L23.6568 12.8555C23.882 12.6303 23.9944 12.3185 23.9942 12.0065H15.9804V20.0261Z"
        fill={color}
      />
      <path
        d="M15.9804 3.98696C15.6711 3.98526 15.3616 4.10116 15.1255 4.33726L8.30401 11.1576C8.07881 11.3828 7.96641 11.6946 7.96661 12.0066H15.9804V3.98696Z"
        fill={color}
      />
      <path
        d="M7.9608 12.0065C7.9591 12.3158 8.075 12.6253 8.3111 12.8614L15.1314 19.6829C15.3566 19.9081 15.6684 20.0205 15.9804 20.0203V12.0065H7.9608Z"
        fill={color}
      />
      <path
        d="M7.8482 11.5391L1.7917 6.49207C1.5671 6.29977 1.2012 6.45687 1.2012 6.76867V12.0001H8.064C8.064 11.8296 7.9921 11.659 7.8482 11.5391Z"
        fill={color}
      />
      <path
        d="M7.8482 12.4611L1.7917 17.5081C1.5671 17.7004 1.2012 17.5433 1.2012 17.2315V12.0001H8.064C8.064 12.1706 7.9921 12.3412 7.8482 12.4611Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastNextkeyNsk.displayName = 'PlayblastNextkeyNsk';
